import * as Yup from 'yup';

export const CreateAppointmentSchema = Yup.object().shape({
    diagnose: Yup.string()
    .matches(/^[A-Za-z\s]+$/, 'Diagnose name should only contain letters')
    .required('Diagnose name is required'),
    date: Yup.date().required("Date is required"),
  });
